import { SecuritySchemeElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class SecurityScheme extends SecuritySchemeElement {
  /**
   * OpenAPI 3.2: OAuth 2.0 metadata URL for discovering OAuth2 configuration.
   */
  get oauth2MetadataUrl() {
    return this.get('oauth2MetadataUrl');
  }
  set oauth2MetadataUrl(oauth2MetadataUrl) {
    this.set('oauth2MetadataUrl', oauth2MetadataUrl);
  }

  /**
   * OpenAPI 3.2: Marks this security scheme as deprecated.
   */
  get deprecated() {
    return this.get('deprecated');
  }
  set deprecated(deprecated) {
    this.set('deprecated', deprecated);
  }
}
export default SecurityScheme;